import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconDashboardBlackboard = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M5.25 6.25C5.25 5.83579 5.58579 5.5 6 5.5H7C7.41421 5.5 7.75 5.83579 7.75 6.25C7.75 6.66421 7.41421 7 7 7H6C5.58579 7 5.25 6.66421 5.25 6.25Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6 8.5C5.58579 8.5 5.25 8.83579 5.25 9.25C5.25 9.66421 5.58579 10 6 10H10C10.4142 10 10.75 9.66421 10.75 9.25C10.75 8.83579 10.4142 8.5 10 8.5H6Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.25 12.25C5.25 11.8358 5.58579 11.5 6 11.5H10C10.4142 11.5 10.75 11.8358 10.75 12.25C10.75 12.6642 10.4142 13 10 13H6C5.58579 13 5.25 12.6642 5.25 12.25Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M15 5.5C14.0335 5.5 13.25 6.2835 13.25 7.25V9.25C13.25 10.2165 14.0335 11 15 11H17C17.9665 11 18.75 10.2165 18.75 9.25V7.25C18.75 6.2835 17.9665 5.5 17 5.5H15ZM14.75 7.25C14.75 7.11193 14.8619 7 15 7H17C17.1381 7 17.25 7.11193 17.25 7.25V9.25C17.25 9.38807 17.1381 9.5 17 9.5H15C14.8619 9.5 14.75 9.38807 14.75 9.25V7.25Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6 2.5C3.92893 2.5 2.25 4.17893 2.25 6.25V13.25C2.25 15.3211 3.92893 17 6 17H6.82553L5.13385 21.221C4.97975 21.6055 5.16652 22.0421 5.55101 22.1962C5.93549 22.3503 6.3721 22.1635 6.52619 21.779L8.44151 17H11.25V21.5C11.25 21.9142 11.5858 22.25 12 22.25C12.4142 22.25 12.75 21.9142 12.75 21.5V17H15.5585L17.4738 21.779C17.6279 22.1635 18.0645 22.3503 18.449 22.1962C18.8335 22.0421 19.0203 21.6055 18.8662 21.221L17.1745 17H18C20.0711 17 21.75 15.3211 21.75 13.25V6.25C21.75 4.17893 20.0711 2.5 18 2.5H6ZM3.75 6.25C3.75 5.00736 4.75736 4 6 4H18C19.2426 4 20.25 5.00736 20.25 6.25V13.25C20.25 14.4926 19.2426 15.5 18 15.5H6C4.75736 15.5 3.75 14.4926 3.75 13.25V6.25Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconDashboardBlackboard as ReactComponent };
